import { render, staticRenderFns } from "./IndexOrdenesCompra.vue?vue&type=template&id=31e1cf07&scoped=true"
import script from "./IndexOrdenesCompra.vue?vue&type=script&lang=js"
export * from "./IndexOrdenesCompra.vue?vue&type=script&lang=js"
import style0 from "spinkit/spinkit.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./IndexOrdenesCompra.vue?vue&type=style&index=1&id=31e1cf07&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e1cf07",
  null
  
)

export default component.exports